import { useEffect } from 'react';
import { useToast } from './ui/Toast';
import { setToastActions } from '../utils/notifications';

export function NotificationInitializer() {
  const { showToast } = useToast();
  
  useEffect(() => {
    setToastActions({ showToast });
  }, [showToast]);
  
  return null;
}